import EditorOverlayNew from './EditorOverlayNew';
export default EditorOverlayNew;
//# sourceMappingURL=index.js.mapimport EditorOverlayNew from './EditorOverlayNew';
export default EditorOverlayNew;
//# sourceMappingURL=index.js.map